/**
 * The preview email in a sandboxed frame, as tall as the email so it never scrolls on its own. The
 * frame runs no scripts; same-origin is allowed only so its height can be read.
 */
import { useCallback, useMemo, useState } from 'react';

const FRAME_STYLE = 'html,body{margin:0;padding:0;background:#fff}body{padding:2px 0}';

export function useEmailFrame(html: string | null | undefined) {
  const [height, setHeight] = useState(240);

  const srcDoc = useMemo(
    () =>
      html
        ? `<!doctype html><html><head><meta charset="utf-8"><style>${FRAME_STYLE}</style></head><body>${html}</body></html>`
        : '',
    [html],
  );

  const onLoad = useCallback((event: React.SyntheticEvent<HTMLIFrameElement>) => {
    const document = event.currentTarget.contentDocument;
    if (document) setHeight(Math.max(120, document.documentElement.scrollHeight));
  }, []);

  return { srcDoc, height, onLoad };
}
